<template>
  <v-dialog :model-value="modelValue" max-width="520" @update:model-value="$emit('update:modelValue', $event)">
    <v-card class="px-6 py-5">
      <div class="text-subtitle-1 font-weight-semibold d-flex align-center ga-2">
        <v-icon color="error" size="20">mdi-phone-off-outline</v-icon>
        {{ $t("ncrm.contacts.dataProtection.callWarning.title") }}
      </div>
      <p class="text-body-2 mt-3">{{ $t("ncrm.contacts.dataProtection.callWarning.body", { phone }) }}</p>
      <p class="text-body-2 text-medium-emphasis mt-2">{{ $t("ncrm.contacts.dataProtection.callWarning.hint") }}</p>
      <div class="d-flex justify-end flex-wrap ga-2 mt-5">
        <v-btn variant="text" @click="$emit('update:modelValue', false)">
          {{ $t("ncrm.contacts.dataProtection.callWarning.cancel") }}
        </v-btn>
        <v-btn color="error" prepend-icon="mdi-phone-outline" @click="$emit('confirm')">
          {{ $t("ncrm.contacts.dataProtection.callWarning.confirm") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
// GDPR S9 (GDPR-122) — avertizare înainte de apelul unui număr cu opoziție/retragere pe canalul telefon.
// Nu blochează: apelurile contractuale sau de suport rămân posibile prin „Sun oricum”.
export default {
  name: "NcrmPrivacyCallWarningDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    phone: { type: String, default: "" },
  },
  emits: ["update:modelValue", "confirm"],
};
</script>
